<!--
 * @Author: lishiqiao
 * @Date: 2022-01-10 10:44:02
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-12 14:11:01
-->
<template>
  <div class="page-list">
    <!-- 搜索栏 -->
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <div class="page-search-item">
          <label>年份&nbsp;:</label>
          <el-date-picker v-model="params.params.year" value-format="yyyy" type="year" placeholder="请选择年份">
          </el-date-picker>
        </div>
        <div class="page-search-item">
          <label>公司&nbsp;:</label>
          <el-select v-model="params.params.orgId" placeholder="请选择公司">
            <el-option label="全部公司" value=""></el-option>
            <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品类&nbsp;:</label>
          <el-select v-model="params.params.breedTypeId" placeholder="请选择品类">
            <el-option label="全部品类" value=""></el-option>
            <el-option v-for="item in breedTypeList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品种&nbsp;:</label>
          <el-select v-model="params.params.breedId" placeholder="请选择品种">
            <el-option label="全部品种" value=""></el-option>
            <el-option v-for="item in breedList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="page-search-btn">
        <div class="search-btn" @click="search">查询</div>
        <div class="reset-btn" @click="reset">重置</div>
        <div class="search-close-btn">
          <div @click="PageSearchClose" v-if="PageDisplay">
            <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
          </div>
          <div @click="PageSearchOn" v-else>
            <span>展开</span><i class="iconfont icon-List-Collapse"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="page-list-content">
      <!-- 列表 -->
      <div class="page-list-title">
        <div><i class="title-icon"></i>年度目标完成情况明细表-育苗</div>
        <div>单位 : {{ unitName }}</div>
        <div>年份 : {{ showYear }}年</div>
        <div>
          <el-dropdown style="margin-right: 30px;" @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span class="switch-table" @click="switchTable">汇总</span>
          <span @click="exportTable">
            <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
          </span>
        </div>
      </div>
      <!-- 表格 -->
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" :row-class-name="tableRowClassName"
        @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="orgName" label="公司"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="breedTypeName" label="养殖品类">
        </el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="seedlingDataName" label="育苗批次">
        </el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="breedName" label="品种"> </el-table-column>
        <el-table-column label="投卵量(公斤)">
          <el-table-column prop="putNumberTarget" label="计划">
          </el-table-column>
          <el-table-column prop="putNumber" label="实际"> </el-table-column>
          <el-table-column prop="putNumberComplete" label="完成比例%">
          </el-table-column>
        </el-table-column>
        <el-table-column label="产量(万尾)">
          <el-table-column prop="harvestWeightTarget" label="计划">
          </el-table-column>
          <el-table-column prop="harvestWeight" label="实际"> </el-table-column>
          <el-table-column prop="harvestWeightComplete" label="完成比例%">
          </el-table-column>
        </el-table-column>
        <el-table-column label="产值(万元)">
          <el-table-column prop="harvestMoneyTarget" label="计划">
          </el-table-column>
          <el-table-column prop="harvestMoney" label="实际"> </el-table-column>
          <el-table-column prop="harvestMoneyComplete" label="完成比例%">
          </el-table-column>
        </el-table-column>
        <el-table-column label="利润(万元)">
          <el-table-column prop="harvestProfitTarget" label="计划">
          </el-table-column>
          <el-table-column prop="harvestProfit" label="实际"> </el-table-column>
          <el-table-column prop="harvestProfitComplete" label="完成比例%">
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import service from "./ym-annals-target-service";
import Page from "@/utils/methods/page";
export default {
  name: "detail",
  data() {
    return {
      PageDisplay: true, // 展开收起
      unitName: "", // 单位名称
      showYear: "", // 显示的年份
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "orgName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedTypeName",
          fixed: false,
          selected: false
        },
        {
          prop: "seedlingDataName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedName",
          fixed: false,
          selected: false
        },
      ],
      params: {
        currPage: 1,
        pageSize: 10,
        orderBy: "desc",
        orderByName: "org_name",
        params: {
          rootOrgId: "", // 顶级机构id
          year: localStorage.getItem("year") ? localStorage.getItem("year") : this.$moment().year().toString(), // 年份
          orgId: "", // 公司 机构id
          breedTypeId: "", // 品类id
          breedId: "", // 品种id
          pageType: "0", // 1汇总 0 明细
          breedTypeClass: "egg", // fish养成 egg育苗
        },
      },
      exportParams: {}, // 导出参数
      tableData: [],
      companyList: [], // 公司列表
      breedTypeList: [], // 品类列表
      breedList: [], // 品种列表
    };
  },
  created() {
    this.tableHeight = window.innerHeight - 400;
    this.params.params.rootOrgId = localStorage.getItem("rootId");
    this.getCompanyList(); // 获取公司列表
    this.getBreedTypeList(); // 获取品类列表
    this.getBreedList(); // 获取品种列表
    this.getPageList(); // 获取分页
  },
  mounted() {
    Page.pagesTableFixed(); // 表头固定
  },
  methods: {
    // 切换汇总表
    switchTable() {
      this.$emit("getPageType", "summary");
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 09:48:20
     * @description: 获取公司列表
     * @param {*}
     */
    getCompanyList() {
      service
        .getCompanyList(this.params.params.rootOrgId)
        .then((res) => {
          if (res.code == "0000") {
            this.companyList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 09:49:55
     * @description: 获取品类列表
     * @param {*}
     */
    getBreedTypeList() {
      service
        .getBreedTypeList(this.params.params.rootOrgId)
        .then((res) => {
          if (res.code == "0000") {
            this.breedTypeList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 09:50:39
     * @description: 获取品种列表
     * @param {*}
     */
    getBreedList() {
      service
        .getBreedList(this.params.params.rootOrgId)
        .then((res) => {
          if (res.code == "0000") {
            this.breedList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 查询
    search() {
      this.getPageList();
    },

    // 重置
    reset() {
      this.params.params.year = localStorage.getItem("year") ? localStorage.getItem("year") : this.$moment().year().toString();
      this.params.params.orgId = "";
      this.params.params.breedTypeId = "";
      this.params.params.breedId = "";
      this.getPageList();
    },

    // 收起
    PageSearchClose() {
      Page.PageSearchClose(this);
    },

    // 展开
    PageSearchOn() {
      Page.PageSearchOn(this);
    },

    // 合计行高亮class赋予
    tableRowClassName({ row, rowIndex }) {
      if (row.orgName === "合计") {
        return "heji-row";
      }
    },

    // 显示的单位-年-月-日
    showListData() {
      if (this.params.params.year) {
        this.showYear = this.params.params.year;
      }
      if (this.params.params.orgId) {
        this.unitName = this.companyList.filter(
          (item) => item.id == this.params.params.orgId
        )[0].name;
      } else {
        this.unitName = "恒兴水产养殖事业部";
      }
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-10 14:50:03
     * @description: 获取育苗明细分页
     * @param {*}
     */
    getPageList() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      service
        .getPageList(this.params)
        .then((res) => {
          if (res.code == "0000") {
            this.tableData = res.data.list;
            this.showListData();
            this.exportParams = JSON.parse(JSON.stringify(this.params.params));
          } else {
          }
          loading.close();
        })
        .catch((err) => {
          this.$message.error(err);
          loading.close();
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-10 15:49:07
     * @description:导出
     * @param {*}
     */
    exportTable() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.exportParams.fileName = "育苗年度经营目标完成情况明细";
          service
            .exportData(this.exportParams)
            .then((res) => { })
            .catch((err) => {
              this.$message.error(err);
            });
        })
        .catch((err) => {
          // this.$message.error(err);
        });
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
};
</script>

<style lang="less" scoped></style>